// extracted by mini-css-extract-plugin
export default {"progressPlaceholder":"YzfT6WRebYUcJNY5_g_C"};